import store from '@/state/store';

export const hasGroup = (groups) => {
    let clientGroups = store.getters['auth/user'].serverGroups;
    
    return !!clientGroups.find(clientGroup => {
        return !!groups.find(group => {
            return group.sgid ? clientGroup.sgid == group.sgid : clientGroup.sgid == group;
        });
    });
}